import React from "react";
import { useLocation } from "react-router-dom";
import * as urlService from "./urlService";
import SortableHeaderContent from "./SortableHeaderContent";

/**
 * Default table component.
 *
 * @param headers {array} - table headers.
 * @param children {array<component>} - rows to render.
 * @param containsEditButton {boolean} - add additional th for the edit button column
 */
export function Table({ headers, children, containsEditButton = true, className = "" }) {
    useLocation();
    const sort = urlService.getSort(true);
    const normalizedHeaders = headers.filter(Boolean);

    return (
        <div className="oct_table-responsive-wrapper-v2">
            <table className={`oct_table-v2 ${className}`.trim()}>
                <thead>
                    <tr>
                        {normalizedHeaders.map((header, index) => {
                            const direction = header.sortKey ? sort[header.sortKey] : null;
                            const headerClassName = [
                                header.className || "",
                                header.sortKey ? "oct_mousecursor-pointer oct_table-sortable" : ""
                            ].filter(Boolean).join(" ");

                            return (
                                <th
                                    key={index}
                                    className={headerClassName}
                                    width={header.width || "auto"}
                                    onClick={header.onClick ? () => header.onClick() : undefined}
                                    aria-sort={header.sortKey
                                        ? (direction === "asc" ? "ascending" : direction === "desc" ? "descending" : "none")
                                        : undefined}
                                >
                                    <SortableHeaderContent
                                        label={header.name}
                                        sortable={Boolean(header.sortKey)}
                                        direction={direction}
                                    />
                                </th>
                            );
                        })}
                        {containsEditButton && <th data-orderable="false"></th>}
                    </tr>
                </thead>
                <tbody>
                    {/* {children.map(row =>
                    <>
                        {row}
                    </>
                )} */}
                    {children.map((row, index) =>
                        <React.Fragment key={index}>
                            {row}
                        </React.Fragment>
                    )}
                </tbody>
            </table>
        </div>
    );
}
